'use client';

import { useEffect, useState } from 'react';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';

type ImageWrapperProps = {
  src: string;
  className: string;
  fill: boolean;
  fallbackSrc?: string;
  alt: string;
  width?: number;
  height?: number;
  isOverviewImage?: boolean;
};

export const ImageWrapper = ({
  src,
  className,
  fill,
  fallbackSrc,
  alt,
  width,
  height,
  isOverviewImage,
}: ImageWrapperProps) => {
  const [overviewImageWidth, setOverviewImageWidth] = useState(0);
  useEffect(() => {
    if (isOverviewImage) {
      const tempImage = new window.Image();
      tempImage.src = src;
      tempImage.onload = () => {
        setOverviewImageWidth(tempImage.width);
      };
    }
  }, [isOverviewImage, src]);
  const overviewImageClassName = overviewImageWidth < 215 ? 'object-contain' : 'object-cover';
  return (
    <ImageWithFallback
      src={src || undefined}
      className={isOverviewImage ? overviewImageClassName : className}
      fill={fill}
      fallbackSrc={fallbackSrc}
      alt={alt}
      width={width}
      height={height}
    />
  );
};
